import React, { useState, useContext } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import colors from "../../config/colors";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import UserContext from "../../context/UserContext";
import NtModalUnactiveButton from "../../components/NtModalUnactiveButton";
import NtModalActiveButton from "../../components/NtModalActiveButton";
import {
  handlePinUploadCreate,
  handlePinUploadFailure,
} from "../utils/PinUploadParser";
import NtListHeader from "../../components/NtListHeader";
import pintypesdata from "../data/pintypesdata";
import NtListRow from "../../components/NtListRow";
import NtTabController from "../../components/NtTabController";
import Logger from "../../common/utils/Logger";
import { parseSimpleDisplayDate } from "../../common/utils/ControllerUtils";
import NtModalTitle from "../../components/NtModalTitle";
import NtModalSubtitle from "../../components/NtModalSubtitle";

function NtPinmanagementUploadForm({ type, onCancel, onUploaded }) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [tab, setTab] = useState(pintypesdata[0]);

  const context = useContext(UserContext);

  const exampleCsvColumnData = [
    {
      id: "pin",
      title: "pin",
    },
    {
      id: "name",
      title: "name",
    },
    {
      id: "type",
      title: "type",
    },
    {
      id: "tariff",
      title: "tariff",
    },

    {
      id: "expirationdate",
      title: "expirationdate",
    },
  ];
  const exampleCsvData = {
    name: "name",
    pin: "1234",
    expirationdate: new Date(),
    type: "admin",
    tariff: "admin",
  };

  const handleUpload = async () => {
    setLoading(true);
    const response = await handlePinUploadCreate(
      file,
      context.user?.domain
    );
    setLoading(false);
    setUploadResponse(response);
  };

  const handleDone = () => {
    if (onUploaded) {
      onUploaded(uploadResponse);
    }
  };

  const handleFailureDownload = async () => {
    const response = await handlePinUploadFailure(uploadResponse.failure);
    const fileData = response.data;

    const blob = new Blob([fileData], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "failure-uploaded-pins.txt";
    link.href = url;
    link.click();
  };

  const isRequiredFields = () => {
    return file;
  };

  const changeHandler = async (event) => {
    setFile(event.target.files[0]);
  };

  const renderChooseCSV = () => {
    if (file) {
      return null;
    }
    return (
      <NtTouchableEffect
        style={{}}
        onPress={() => {
          document.getElementById("selectFile").click();
        }}
      >
        <NtText style={{ fontSize: 13, fontWeight: "400", color: colors.blue }}>
          Choose CSV file
        </NtText>
      </NtTouchableEffect>
    );
  };

  const renderInfoCSV = () => {
    if (!file) {
      return null;
    }
    return (
      <View>
        <NtText>{file?.name}</NtText>
      </View>
    );
  };

  return (
    <View style={styles.container}>
      <NtModalTitle>
        Upload csv {type?.id == "cabin" ? "Cabin" : "Pin"} List
      </NtModalTitle>
      <NtModalSubtitle style={[{ marginTop: 4 }]}>
        This will allow to upload a bulk amount. Please follow example below for
        columns and values for each type
      </NtModalSubtitle>

      <View
        style={{
          backgroundColor: colors.lighestGray,
          padding: 15,
          borderRadius: 15,
          marginTop: 20,
        }}
      >
        <NtText
          style={{ fontSize: 14, fontWeight: "600", color: colors.lighGray }}
        >
          Example
        </NtText>
        <NtTabController
          containerStyle={{ marginTop: 20, marginBottom: 10 }}
          options={pintypesdata}
          selection={tab}
          onPress={(item) => {
            if (item?.id == tab?.id) {
              //no need to reload since we are not changing tabs
              return;
            }

            setTab(item);
          }}
        />

        <NtListHeader
          selectedColumns={exampleCsvColumnData}
          overideColumnName={[
            {
              id: "pin",
              title: tab?.id == "cabin" ? "cabin" : "pin",
            },
          ]}
        />

        <NtListRow
          item={exampleCsvData}
          columns={exampleCsvColumnData}
          renderCustom={(item, column) => {
            if (tab.id == "admin") {
              if (column == "credit") {
                return " ";
              }
            } else if (tab.id == "cabin") {
              if (column == "credit" || column == "expirationdate") {
                return " ";
              }
            }

            if (column == "expirationdate") {
              return parseSimpleDisplayDate(item[column]);
            }

            if (column == "type") {
              return tab.id;
            }

            if (column == "tariff") {
              return tab.id;
            }
          }}
        />
      </View>

      <View
        style={{
          borderRadius: 4,
          borderWidth: 1,
          borderColor: colors.lightest,
          backgroundColor: colors.lighestGray,
          justifyContent: "center",
          padding: 10,
          marginTop: 30,
        }}
      >
        {renderChooseCSV()}
        {renderInfoCSV()}
      </View>
      {uploadResponse && (
        <View
          style={{
            marginTop: 6,
          }}
        >
          <NtText style={[styles.uploadResponseText]}>
            Total: {uploadResponse?.total}
          </NtText>
          <NtText style={[styles.uploadResponseText, { marginTop: 4 }]}>
            Success: {uploadResponse?.success?.length}
          </NtText>
          <NtTouchableEffect
            style={{ marginTop: 4 }}
            onPress={() => {
              if (uploadResponse?.failure?.length > 0) {
                handleFailureDownload();
              }
            }}
          >
            <NtText style={[styles.uploadResponseText, { color: "#e05b59" }]}>
              Error: {uploadResponse?.failure?.length}
            </NtText>
          </NtTouchableEffect>
        </View>
      )}

      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 25,
        }}
      >
        {loading && (
          <NtActivityIndicator
            color={colors.blue}
            size="small"
            containerStyle={{ marginRight: 25 }}
          />
        )}

        <NtModalUnactiveButton title={"Cancel"} onPress={onCancel} />
        <NtModalActiveButton
          containerStyle={{ marginLeft: 15 }}
          title={uploadResponse ? "Done" : "Upload"}
          onPress={
            isRequiredFields()
              ? () => {
                  if (uploadResponse) {
                    handleDone();
                  } else {
                    handleUpload();
                  }
                }
              : null
          }
          enabled={isRequiredFields()}
        />
      </View>

      <input
        id="selectFile"
        type="file"
        name="file"
        accept=".csv"
        style={{ display: "none" }}
        onChange={changeHandler}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minWidth: 500,
    maxWidth: 600,
    padding: 15,
  },
  cancelButton: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.darkest,
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
  },
  addButton: {
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
    backgroundColor: colors.lighGray,
  },
  uploadResponseText: {
    fontSize: 13,
    fontWeight: "600",
    color: colors.darkest,
  },
});

export default NtPinmanagementUploadForm;
